
export default [
    {
        path: '/lifecircle/picdetail',
        component: () => import('@/pages/lifecircle/pic-detail.vue'),
        meta: {
            title: '我在销巴生活圈发现了一个秘密',
        }
    },
    {
        path: '/lifecircle/videodetail',
        component: () => import('@/pages/lifecircle/video-detail.vue'),
        meta: {
            title: '我在销巴生活圈发现了一个有…',
        }
    },
    {
        path: '/lifecircle/integral',
        component: () =>
            import('@/pages/lifecircle/integral.vue'),
        meta: {
            title: '玩转积分'
        }
    },
    {
        path: '/lifecircle/topicActivity',
        component: () =>
            import('@/pages/lifecircle/topic-activity.vue'),
        meta: {
            title: '话题活动'
        }
    }
    
]